import React, { FC, ReactNode, useCallback, useEffect, useState } from "react";
import { Button } from "@shared/components";
import "./DataSiftRedirect.scss";

interface DataSiftRedirectProps {
  redirectUrl?: string;
  autoRedirectTime?: number; // in seconds
  title?: ReactNode;
  description?: ReactNode;
  buttonText?: string;
}

const DataSiftRedirect: FC<DataSiftRedirectProps> = ({
  redirectUrl = "https://app.reisift.io/signup/account",
  autoRedirectTime = 5,
  title = "Welcome to the new DataSift platform",
  description = (
    <>
      DataSift is the new and improved platform replacing DataFlik.
      <br />
      New accounts are now created in DataSift.
    </>
  ),
  buttonText = "Continue to signup",
}) => {
  const [countdown, setCountdown] = useState(autoRedirectTime);

  const handleRedirect = useCallback(() => {
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [redirectUrl, handleRedirect]);

  return (
    <div className="datasift-redirect">
      <div className="datasift-redirect-container">
        <div className="datasift-redirect-title">{title}</div>
        <div className="datasift-redirect-text">{description}</div>
        <div className="datasift-redirect-countdown">Redirecting in {countdown} seconds...</div>
        <div className="datasift-redirect-button">
          <Button buttonStyle="accent-green" onClick={handleRedirect}>
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DataSiftRedirect;
